module.exports = __webpack_public_path__ + "img/Flash_off.c9b6de4c.svg";